// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"c2847739","156":"a2aff8cd","224":"e86f5cd4","591":"454177fb","682":"612286df","825":"f656c6c6","828":"f52e03d6","962":"2ef85209"}[chunkId] + ".chunk.js";
};